import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { SortDescriptor } from '@progress/kendo-data-query';
import { bookKeepingInvoiceListDelete, bookKeepingInvoiceListUpdate } from 'src/app/shared/helpers/auth-config/bookkeeping.config';
import { SortOrder } from 'src/app/shared/modules/graphql/enums/generic.enums';
import { IApiSageInvoiceFilter, IApiSageInvoiceOrderBy, IApiUserFilterType } from 'src/app/shared/modules/graphql/types/types';
import { LoaderService } from 'src/app/shared/modules/loader/loader.service';
import { InvoiceService } from 'src/app/shared/services';
import { SageInvoiceDataSource } from 'src/app/shared/services/invoice/sage-invoice.datasource';

@Component({
  selector: 'app-bookkeeping-sage-invoice-list',
  templateUrl: './bookkeeping-sage-invoice-list.component.html',
  styleUrls: ['./bookkeeping-sage-invoice-list.component.scss']
})
export class BookkeepingSageInvoiceListComponent implements OnInit {
  public authConfig = {
    bookKeepingInvoiceListUpdate,
    bookKeepingInvoiceListDelete
  }
  // @ViewChild('filterForm', { static: false }) filterForm: NgForm;
  public filtersActive = false;

  // Table Setup
  private _dataSource: SageInvoiceDataSource;
  public get dataSource() {
    return this._dataSource;
  }
  public set dataSource(val) {
    this._dataSource = val;
  }
  public displayedColumns = ["invoice", "invId", "billTo", "client", "createdBy", "createdAt", "status", "qbErrors", "actions"];
  public pageSize: number = null;
  public totalResults = 0;

  // Filter options
  public searchValue: string = null;
  public invoiceNumber: number = null;
  public investigationId: string = null;
  public createdBy = null;
  public startDate = null;
  public endDate = null;

  // Select options - need to be fetched
  public invoices = null;
  public investigations = null;
  public orderByOptions = IApiSageInvoiceOrderBy;
  public userViewFilter = IApiUserFilterType.ViewStaffUser;
  public sort: SortDescriptor[] = [
    {
      field: IApiSageInvoiceOrderBy.DueDate,
      dir: "asc",
    },
  ];

  public get pageOptions() {
    if (!this._dataSource) return null;
    return this._dataSource.listPage;
  }

  constructor(
    private invoiceService: InvoiceService,
    private loader: LoaderService
  ) {
    this.dataSource = new SageInvoiceDataSource(this.invoiceService);
    this.dataSource.listPage.orderBy = IApiSageInvoiceOrderBy.Id;
    this.dataSource.listPage.sortOrder = SortOrder.DESC;
  }

  ngOnInit() {
    this.loader.attachObservable(this.dataSource.loading$);
    this.load();
  }

  public load() {
    this.dataSource.pagingReset();
    this.dataSource.load();
  }

  public sortChange = (e) => {
    this.sort = e;
    if (e && e?.[0]?.dir) {
      this.dataSource.listPage.orderBy = e?.[0]?.field;
      this.dataSource.listPage.sortOrder =
        e?.[0]?.dir === "asc" ? SortOrder.ASC : SortOrder.DESC;
    } else {
      this.dataSource.listPage.orderBy = IApiSageInvoiceOrderBy.DueDate;
      this.dataSource.listPage.sortOrder = SortOrder.ASC;
    }
    this.load();
  };

  public changeFilters(filters: IApiSageInvoiceFilter[]) {
    this.dataSource?.lastFilters?.map(filter => this.dataSource.applyFilter(filter?.type, null));
    filters?.map(filter => this.dataSource.applyFilter(filter?.type, filter?.value));
    this.dataSource.pagingReset();
    this.load();
  }

}
